<template>
  <b-dropdown @hidden="dropdownClose = true" @show="dropdownClose = false" :menu-class="menuClass" size="md" variant="link" toggle-class="text-decoration-none" no-caret>
    <template #button-content>
      <div v-if="pagination" class="__pagintaiond__dropdown">
        {{ currentValue.value }}
        <i v-if="dropdownClose" class="fas fa-caret-down"></i>
        <i v-else class="fas fa-caret-up"></i>
      </div>
      <!--  -->
      <!-- three dot image -->
      <div v-if="simpleDropdown">
        <img src="@/assets/images/three-dots.svg" />
      </div>
    </template>

    <b-dropdown-item v-for="item in items" :key="item.id" @click="changeValue(item.id)">
      {{ item.value }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { urlQueriesMixins } from '../../utils/mixins'
export default {
  name: 'dropdown',
  components: {},
  mixins: [urlQueriesMixins],
  props: {
    items: {
      type: Array,
    },
    simpleDropdown: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Boolean,
      default: false,
    },
    menuClass: {
      type: String,
    },
  },
  data() {
    return {
      currentValue: null,
      dropdownClose: true,
    }
  },
  mounted() {
    if (this.pagination) {
      this.findDefaultValue()
    } else return
  },
  methods: {
    changeValue(id) {
      this.currentValue = this.items.find((el) => el.id === id)
      this.$emit('dropdownSelected', this.currentValue)
    },
    findDefaultValue() {
      this.currentValue = this.items.find((el) => el.count == this.pageSize)
    },
  },
}
</script>

<style scoped>
::v-deep .style li a:hover {
  background-color: rgba(66, 133, 242, 0.2) !important;
}
::v-deep .style li a:hover {
  background-color: rgba(66, 133, 242, 0.2) !important;
}
::v-deep .style li a:focus {
  background-color: rgba(66, 133, 242, 0.2) !important;
}
::v-deep .style li a:focus {
  background-color: rgba(66, 133, 242, 0.2) !important;
}
img {
  width: 4px;
}

.__pagintaiond__dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: black;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 5px 10px;
}

.__priorities__dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

i {
  color: #999999;
  font-size: 16px;
}
::v-deep .btn-check:focus + .btn,
::v-deep .btn:focus {
  /* outline: 0; */
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
::v-deep .dropdown-menu {
  padding: 0 0.2rem 0 !important;
}
@media (max-width: 378px) {
  .__pagintaiond__dropdown {
    font-size: 12px !important;
  }
}
</style>
